import { useEffect, useState } from "react";
import { Trophy, Check, ChevronDown } from "lucide-react";
import { api, C } from "../lib/api";

// VIP points for games played: 2 a game, banked until you have played every game the room offers.
export const VipGamesSection = () => {
  const [v, setV] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { let on = true; api.get(C.ApiRoutes.MY_VIP).then((r) => on && setV(r.data)).catch(() => {}); return () => { on = false; }; }, []);
  if (!v) return null;
  const pct = v.total ? Math.round((v.played / v.total) * 100) : 0;
  return (
    <section data-testid="drawer-vip-games">
      <button data-testid="vip-games-toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open}
        className="w-full flex items-center justify-between py-1 text-left">
        <div className="text-[11px] uppercase tracking-[0.3em] gold-text flex items-center gap-2"><Trophy className="w-3.5 h-3.5" /> VIP · games played</div>
        <span className="text-[10px] text-slate-500 flex items-center gap-1">
          <span className="font-mono text-amber-200/90">{v.played}/{v.total}</span> · {v.banked} banked
          <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      {!open ? null : (
      <div className="mt-2">
      <div className="flex items-end justify-between">
        <div>
          <div data-testid="vip-games-banked" className="font-mono text-2xl text-amber-50">{v.banked}</div>
          <div className="text-[11px] text-slate-400">points waiting · {v.per_game} for every game</div>
        </div>
        <div data-testid="vip-games-progress" className="font-mono text-sm text-amber-200/90">{v.played}/{v.total}</div>
      </div>
      <div className="h-1.5 mt-3 rounded-full bg-black/40 overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-amber-500 to-amber-200 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <p className="text-[11px] text-slate-400 mt-3">
        {v.complete
          ? `Every game played — ${v.paid} VIP points collected. Play any new game we add and the rest follows.`
          : `Play all ${v.total} games and the ${v.banked} points you have banked are paid into your VIP balance. A game counts once you have chips in a hand of it.`}
      </p>
      <div className="mt-3 grid grid-cols-2 gap-1.5">
        {v.games.map((g) => (
          <div key={g.game} data-testid={`vip-game-${g.game}`} data-played={g.played ? "true" : "false"}
            className={`flex items-center gap-1.5 text-[11px] rounded-lg px-2 py-1.5 border ${g.played ? "border-amber-400/30 bg-amber-400/5 text-amber-100" : "border-white/5 text-slate-500"}`}>
            {g.played ? <Check className="w-3 h-3 shrink-0 text-emerald-400" /> : <span className="w-3 h-3 shrink-0 rounded-full border border-white/20" />}
            <span className="truncate" title={g.label}>{g.label.replace(/^No-Limit |^Pot-Limit |^Fixed-Limit /, "")}</span>
          </div>
        ))}
      </div>
      </div>
      )}
    </section>
  );
};
